import { render, staticRenderFns } from "./jiameng.vue?vue&type=template&id=1f5d7f5a&scoped=true&"
import script from "./jiameng.vue?vue&type=script&lang=js&"
export * from "./jiameng.vue?vue&type=script&lang=js&"
import style0 from "./jiameng.vue?vue&type=style&index=0&id=1f5d7f5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d7f5a",
  null
  
)

export default component.exports